import rootReducer from '../redux-reducers';
import {createStore} from 'redux';

export default (initialState) => {
  return createStore(rootReducer, initialState);
};



/** WEBPACK FOOTER **
 ** ./src/components/redux-store/configure-store.js
 **/